import * as actions from '../../actions/actionTypes';

const initialState = 0;

export default function status(state = initialState, action) {
  switch (action.type) {
    case actions.INIT_NEW_PROGRAM_RESULT:
      return initialState;
    case actions.SET_NEW_PROGRAM_RESULT:
      if (typeof action.payload.status !== 'undefined') {
        return action.payload.status;
      } else {
        return state;
      }
    default:
      return state;
  }
}
